<template>
  <div class="driver-message">
    <el-dialog
      title="选择商品"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="800px">
      <div class="driver-message-container">
        <el-form
          class="table-search-bar maintain-form"
          inline
          ref="maintainForm"
          :model="maintainForm"
          label-width="70px">
          <el-form-item label="商品名称" prop="productName">
            <el-input v-model="maintainForm.productName" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select v-model="maintainForm.type" placeholder="请选择">
              <el-option
                v-for="item in typeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品分类" prop="category">
            <ajax-cascader v-model="maintainForm.category" placeholder="请选择" type="product"></ajax-cascader>
          </el-form-item>
          <el-form-item label="商品编码" prop="productCode">
            <el-input v-model="maintainForm.productCode" placeholder="请输入商品编码"></el-input>
          </el-form-item>
          <!-- <el-form-item label="产品简称" prop="itemShortName">
            <el-input v-model="maintainForm.itemShortName" placeholder="请输入产品简称"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="handleSearch()" icon="el-icon-search">搜索</el-button>
            <el-button type="primary" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="container-table">
          <el-table
            :data="productData"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :row-key="getRowKey">
            <el-table-column
              type="selection"
              :reserve-selection="true"
              width="55"
              align="center">
              <!-- <template slot-scope="scope">
                <el-checkbox :checked="selectData.some(item => item.itemId === scope.row.itemId)" :key="scope.row.itemId" :disabled="scope.row.disabled === 1" @change="e => handleSelect(e, scope.row)"></el-checkbox>
              </template> -->
            </el-table-column>
            <el-table-column
              prop="itemName"
              label="商品名称"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="itemType"
              :formatter="itemTypeFormatter"
              label="类型"
              width="60"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="itemCode"
              label="商品编码"
              width="100"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="itemShortName"
              label="产品简称"
              width="100"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              label="产品分类"
              width="200"
              :show-overflow-tooltip="true">
              <template slot-scope="scope">{{cateFormatter(scope.row)}}</template>
            </el-table-column>
          </el-table>
        </div>
        <div class="container-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="listState.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listState.total"
            :current-page="listState.pageNo"
            background>
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="finishDialog(0)">取 消</el-button>
        <el-button type="primary" @click="finishDialog(1)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AjaxCascader from '@/components/ajaxCascader/index'

export default {
  name: 'goodsDialog',
  components: { AjaxCascader },
  props: {
    info: Object
  },
  data () {
    return {
      maintainForm: {
        status: '',
        type: '',
        category: [],
        area: '',
        organization: '',
        productName: '',
        productCode: ''
      },
      typeArr: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '自营'
        },
        {
          value: '2',
          label: '贸易'
        }
      ],
      dialogVisible: false,
      selectData: []
    }
  },
  computed: {
    ...mapState({
      productData: state => state.productMaintain.list,
      listState: state => state.productMaintain.listState
    })
  },
  mounted () {
    this.dialogVisible = true
    this.handleSearch(1)
  },
  methods: {
    ...mapActions(['getProductMaintainList']),
    handleSelect (e, item) {
      if (e) {
        this.selectData.push({
          id: item.id,
          itemCode: item.itemCode,
          itemId: item.itemId,
          itemName: item.itemName
        })
      } else {
        this.selectData = this.selectData.filter(_item => _item.itemId !== item.itemId)
      }
    },
    handleSearch (pageNo = 1) {
      const params = {
        ...this.maintainForm,
        pageNo
      }
      this.getProductMaintainList(params)
    },
    itemTypeFormatter (row) {
      switch (row.itemType) {
        case 1:
          return '自营'
        case 2:
          return '贸易'
        default:
          return '-'
      }
    },
    cateFormatter (row) {
      const { itemFirstCateName, itemSecondCateName, itemThirdCateName } = row
      let arr = []
      itemFirstCateName && arr.push(itemFirstCateName)
      itemSecondCateName && arr.push(itemSecondCateName)
      itemThirdCateName && arr.push(itemThirdCateName)
      return arr.join('-')
    },
    reset () {
      this.$refs['maintainForm'].resetFields()
      this.handleSearch()
    },
    // type: 0代表取消 1代表确定选定
    finishDialog (type) {
      this.dialogVisible = false
      this.$emit('update:visibleGoodsMessage', { visibleGoods: false, selectData: type ? this.selectData : [], type })
    },
    handleSizeChange (val) {
      this.getProductMaintainList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getProductMaintainList({ pageNo: val })
    },
    getRowKey (row) {
      return row.itemId
    },
    handleSelectionChange (val) {
      this.selectData = val.map(item => {
        return {
          id: item.id,
          itemCode: item.itemCode,
          itemId: item.itemId,
          itemName: item.itemName
        }
      })
    }
  },
  watch: {
    dialogVisible (newVal, oldVal) {
      console.log('[ newVal ] >', newVal)
      // if (newVal === false) {
      //   this.$emit('update:visibleGoodsMessage', { visibleGoodsMessage: false, selectData: [] })
      // }
    }
  }
}
</script>

  <style lang="scss" scoped>
  /deep/ .el-dialog__headerbtn{
    display: none;
  }
  .driver-message-container {
    margin-bottom: 10px;
    .container-options {
      display: flex;
      justify-content: space-between;
      .el-input__icon.el-icon-search:hover {
        cursor: pointer;
      }
    }
    .container-table {
      margin-top: 20px;
    }
  }
  .driver-message {
    /deep/ .el-dialog {
      width: 800px;
      /deep/ .el-dialog__body {
        padding-bottom: 0px;
      }
    }
  }
  .left-option-block {
    width: 320px;
    .el-input {
      width: 250px
    }
    .el-button {
      margin-left: 4px;
    }
  }
</style>
